import dynamic from "next/dynamic"
import { Notification } from "@/types/notification"

import { Skeleton } from "@/components/ui/skeleton"

const loadNotificationDetails = () =>
  import("./notification-details").then((m) => m.NotificationDetails)

const NotificationDetails = dynamic(loadNotificationDetails, {
  ssr: false,
  loading: () => <NotificationDetailsSkeleton />,
})
const NotificationDetailsToast = dynamic(loadNotificationDetails, {
  ssr: false,
  loading: () => <NotificationDetailsSkeleton toast />,
})

// Defers the ~38 KB notification-details bundle out of `_app`. Both the bell
// dropdown and the push-toast renderer go through this wrapper, so the heavy
// per-type renderer code only loads once the first notification is rendered.
export function NotificationDetailsLazy({
  value,
  toast = false,
}: {
  value: Notification
  toast?: boolean
}) {
  if (toast) {
    return <NotificationDetailsToast value={value} toast />
  }
  return <NotificationDetails value={value} />
}

// Matches the layout NotificationDetails renders (xs avatar = size-7, plus two
// text lines) so the toast/list row doesn't shift when the real component
// hydrates in.
function NotificationDetailsSkeleton({ toast = false }: { toast?: boolean }) {
  return (
    <div
      className={
        toast
          ? "flex min-w-0 flex-1 flex-col gap-1.5 text-left"
          : "flex flex-1 items-start gap-2 text-left"
      }
    >
      {!toast ? <Skeleton className="size-7 shrink-0 rounded-full" /> : null}
      <Skeleton className="h-3 w-3/4 rounded" />
      <Skeleton className="h-3 w-1/3 rounded" />
    </div>
  )
}
